import React from "react";

const Section4 = () => {
  return (
    <div
      className=" bg-black  text-white"
      style={{ backgroundImage: "url(../assets/bg/bg5.svg)" }}
    >
      <div className=" bg-black/50 h-full py-10 ">
        <p className="text-4xl font-bold text-center">Pioneering Stablecoin Solutions</p>
        <div className=" w-[85%] mx-auto flex md:flex-row flex-col items-center mt-10">
          <div>
            <ul className=" list-disc font-sen ">
              <li className=" leading-10 text-lg ">
              Decentralized Gas Management
              </li>
              <li className=" leading-10 text-lg ">
              Next-Generation Token Management
              </li>
              <li className=" leading-10 text-lg ">Built for Compliance and Flexibility</li>
            </ul>
          </div>

          <div className="relative flex justify-center items-center ">
            <img src="../assets/other/Group.svg" />
            <img
              src="../assets/other/btc.svg"
              className="w-8/12 absolute top-7 "
            />
          </div>

          <div>
            <ul className=" list-disc font-sen ">
              <li className=" leading-10 text-lg ">
              Custom Infrastructure Solutions
              </li>
              <li className=" leading-10 text-lg ">
              Intelligent Liquidity Routing
              </li>
              <li className=" leading-10 text-lg ">Operational Transparency</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section4;
